// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"f16eb9b1f09f59114050","655":"6244fea9c54595456aa9"}[chunkId] + ".js";
};